// src/components/Notification.jsx
import React, { useEffect } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa'; // Ícones de certo e X

const Notification = ({ message, type, onClose }) => {
  useEffect(() => {
    // Fecha a notificação automaticamente após 3 segundos
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer); // Limpa o timer ao desmontar o componente
  }, [onClose]);

  return (
    <div className={`notification ${type}`}>
      <div className="notification-content">
        {type === 'success' ? <FaCheck /> : <FaTimes />}
        <span>{message}</span>
      </div>
    </div>
  );
};

export default Notification;